module.exports = __webpack_public_path__ + "img/1x.dd4b70b.jpg";